import { Vector3 } from './types';

/**
 * Calculate dot product of two vectors
 */
export const dot = (a: Vector3, b: Vector3): number => {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
};

/**
 * Calculate cross product of two vectors
 */
export const cross = (a: Vector3, b: Vector3): Vector3 => {
  return [
    a[1] * b[2] - a[2] * b[1],
    a[2] * b[0] - a[0] * b[2],
    a[0] * b[1] - a[1] * b[0]
  ];
};

/**
 * Normalize a vector to unit length
 */
export const normalize = (v: Vector3): Vector3 => {
  const mag = Math.sqrt(dot(v, v));
  return mag === 0 ? [0, 0, 0] : [v[0] / mag, v[1] / mag, v[2] / mag];
};

/**
 * Rotate a vector around an axis by an angle using Rodrigues' rotation formula
 * @param v - Vector to rotate
 * @param k - Axis of rotation (should be normalized)
 * @param theta - Angle in radians
 */
export const rotate = (v: Vector3, k: Vector3, theta: number): Vector3 => {
  const c = Math.cos(theta);
  const s = Math.sin(theta);
  const kDotV = dot(k, v);
  const kxv = cross(k, v);
  
  return [
    v[0] * c + kxv[0] * s + k[0] * kDotV * (1 - c),
    v[1] * c + kxv[1] * s + k[1] * kDotV * (1 - c),
    v[2] * c + kxv[2] * s + k[2] * kDotV * (1 - c)
  ];
};